export default __webpack_public_path__ + "static/media/status1.04342b18.png";